exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui.selection.dropdown .menu > .item {\n  line-height: 10px; }\n\n.ui.selection.dropdown .menu {\n  min-width: calc(147% + 2px) !important;\n  width: calc(247% + 2px) !important; }\n\n.ui.selection.dropdown .menu.ajust-width {\n  min-width: calc(110% + 2px) !important;\n  width: calc(128% + 3px) !important; }\n\n.ui.dropdown .menu > .item {\n  font-size: 0.9rem; }\n\n.text {\n  width: 100%;\n  overflow: hidden; }\n\n.ui.selection.dropdown {\n  cursor: pointer;\n  line-height: 1em;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n  outline: 0;\n  -ms-transform: rotate(0);\n  transform: rotateZ(0);\n  min-height: 2.71428571em;\n  background: #fff;\n  display: inline-block;\n  padding: 0.78571429em 2.1em 0.78571429em 1em;\n  color: rgba(0, 0, 0, 0.87);\n  box-shadow: none;\n  border: 1px solid rgba(20, 100, 246, 0.5);\n  border-radius: 0;\n  transition: box-shadow .1s ease,width .1s ease; }\n\n.speddcode {\n  border-right: 1px #cccccc solid;\n  width: 60px !important; }\n\n.description {\n  padding-left: 4px; }\n\n.ui.dropdown:hover .menu {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/dropdown-provider/components/dropdown-provider/dropdown-provider.component.scss
// module id = 2182
// module chunks = 66